if (!customElements.get('peptia-science-q03')) {
  customElements.define('peptia-science-q03', class extends HTMLElement {
    connectedCallback() {
      this.signal = this.querySelector('.signal51');
      this.button = this.querySelector('.signal-toggle51');
      if (!this.signal || !this.button) return;
      this.reduce = matchMedia('(prefers-reduced-motion:reduce)');
      this.visible = false;
      this.paused = false;
      this.colorIndex = 0;
      this.colors = ['#F2CE40','#C1E363','#F19A66','#76CEA4','#A8D3E8','#75B6DF','#4DB9BE','#A89BE8','#F2BE70','#DF8B74'];
      this.onCycle = event => { if (!['signal-arrive51','signal-desktop-arrive51'].includes(event.animationName) || !event.target.getClientRects().length) return; this.colorIndex = (this.colorIndex + 1) % this.colors.length; this.signal.style.setProperty('--signal-color', this.colors[this.colorIndex]); };
      this.signal.addEventListener('animationiteration', this.onCycle);
      this.onClick = () => { this.paused = !this.paused; this.playback(); };
      this.onVisibility = () => this.playback();
      this.button.addEventListener('click', this.onClick);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.reduce.addEventListener('change', this.onVisibility);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.playback();
      }, { threshold: .2 });
      this.observer.observe(this.signal);
      this.playback();
    }
    playback() {
      const still = this.reduce.matches || this.dataset.animate !== 'true';
      this.signal.dataset.static = String(still);
      this.signal.dataset.running = String(this.visible && !this.paused && !still && !document.hidden);
      this.button.setAttribute('aria-pressed', String(this.paused));
      this.button.setAttribute('aria-label', this.button.dataset[still ? 'static' : this.paused ? 'resume' : 'pause']);
      this.button.disabled = still;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.signal?.removeEventListener('animationiteration', this.onCycle);
      this.button?.removeEventListener('click', this.onClick);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.reduce?.removeEventListener('change', this.onVisibility);
    }
  });
}


